import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import { IConfirmSchedulePayload } from "../types/dashboard.types";
import { confirmSchedule } from "../services/dashboard.services";

export function useConfirmSchedule() {
    interface ApiResponseData {
        confirmed_sessions: string[];
        unconfirmed_sessions: {
            session_id: string;
            error: string;
        }[];
    }

    return useMutation<
        IApiResponse<ApiResponseData>,
        AxiosError<IApiResponse<ApiResponseData>>,
        IConfirmSchedulePayload
    >({
        mutationKey: ["confirm-schedule"],
        mutationFn: (payload: IConfirmSchedulePayload) =>
            confirmSchedule(payload),
    });
}
